import type {PSSCalculationService, PSSPlansResponse} from '../../../infrastructure/services/ApiPaymentService';
import type {IProductRepository} from '../../../domain/repositories/IProductRepository';
import type {RepScoreService} from '../../../infrastructure/services/RepScoreService';

export interface GetPaymentPlansParams {
    productId: string;
    userId: string;
}

export class GetPaymentPlansUseCase {
    constructor(
        private readonly productRepository: IProductRepository,
        private readonly pssCalculationService: PSSCalculationService,
        private readonly repScoreService: RepScoreService
    ) {
    }

    async execute(params: GetPaymentPlansParams): Promise<PSSPlansResponse> {
        // 1. Validate product exists
        const product = await this.productRepository.findById(params.productId);
        if (!product) {
            throw new Error('Product not found');
        }

        // 2. Check if product is eligible for PSS
        if (!product.isEligibleForPaymentPlan()) {
            throw new Error('Product is not eligible for payment plans');
        }

        // 3. Get PSS payment plans from API
        const pssPlans = await this.pssCalculationService.getPaymentPlans(params.productId);

        // 4. Validate user eligibility
        if (!pssPlans.userEligibility.pssCreditEligible) {
            throw new Error('User is not eligible for PSS credit');
        }

        return pssPlans;
    }
}